import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { CarDetailsTab } from '@features/cars/components/CarDetailsTab'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/cars/staff/$carId/')({
    component: RouteComponent,
})

function RouteComponent() {
    const { carId } = Route.useParams()

    return (
        <div className='h-full min-h-0'>
            <QueryErrorBoundary title='Failed to load car details'>
                <Suspense fallback={<LoadingIndicator resource='car details' />}>
                    <CarDetailsTab carId={carId} ownerType='staff' />
                </Suspense>
            </QueryErrorBoundary>
        </div>
    )
}
